import { Logger } from '@vue-storefront/core/lib/logger'
import VueGtag from 'vue-gtag'
import { router } from '@vue-storefront/core/app'

export function beforeRegistration ({ Vue, config, isServer }) {
  if (config.googleTagManager.id && !isServer) {
    // 3rd arg wires up vue-router so page_view fires automatically on every route change -
    // without it vue-gtag defaults to send_page_view: false and no page_view is ever sent.
    Vue.use(VueGtag, {
      config: { id: config.googleTagManager.id }
    }, router)
  } else {
    Logger.warn('Google Tag Manager extensions is not working. Ensure Google Tag Manager container ID is defined in config', 'GTM')()
  }
}
